import { render } from "./En.vue?vue&type=template&id=74ac44a8"
import script from "./En.vue?vue&type=script&lang=js"
export * from "./En.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tony.waddington/Desktop/Vue/gi-archive/__GITLAB/archive-collections/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__